export default __webpack_public_path__ + "locales/en/SharingPanel.json?hash=9ac912bac12a79899092ae014342d9f2";